import "./Main.css";

function Main() {
  return (
    <div className="main">
      <h3>About</h3>
      <p>
        I'm a dynamic Front-End Web Developer bringing in-depth knowledge of the
        latest technology trends to produce optimized website designs. I'm a
        huge fan of detail-oriented collaboration with others to solve problems.
      </p>
      <h3>Interests</h3>
      <p>
        Chelsea fan. Music Scholar. Reader. Twitter fanatic. Pizza buff. HIMYM
        fan. Writer. FIFA geek
      </p>
    </div>
  );
}

export default Main;
